import { Columns } from '#types/grid';

export function setColumnSize(columns: Columns, field: string, size: number): Columns {
  for (const column of columns) {
    if (column.field === field) {
      column.width = size;
    }
  }

  return columns;
}
